<template>
    <div class="d-flex align-items-center text-right">
        <form-square-switch
            :value="selectedModules[params.data.id]"
            @input="val => params.onToggleModule(val, params.data)"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            :disabled="params.data.component === 'website'"
            :sync="true"
            class="mt-1 toggle-module-button"
        ></form-square-switch>
    </div>
</template>

<script>
    import FormSquareSwitch from '../../generic/form-square-switch/form-square-switch.vue';

    export default {
        components: {
            FormSquareSwitch,
        },
        computed: {
            selectedModules() {
                return this.params.selectedModulesGetter();
            },
        },
        methods: {
            hideModal() {
                this.$bvModal.hide(this.modalId);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    @include media-breakpoint-down(lg) {
        :deep(.toggle-module-button .v-switch-label) {
            padding-top: 0 !important;
        }
    }

    @include media-breakpoint-up(lg) {
        :deep(.toggle-module-button .v-switch-label) {
            padding-top: 0.1em !important;
        }
    }

    :deep(.toggle-module-button .v-switch-core) {
        height: 2.15em !important;
    }

    :deep(.toggle-module-button .v-switch-button) {
        top: 0.15em !important;
        height: 1.8em !important;
    }
</style>
